import auth from './auth'
import sp from './sp'
import file from './file'
import share from './share'


export default {
    auth, sp, file, share
}